import { PublicUploadDocumentsForm } from 'components/publicUploadDocumentsForm';
import { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

export const PublicUploadDocumentsPage: FC = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route path=":userUid" element={<PublicUploadDocumentsForm />} />
    </Route>
  </Routes>
);
